<template>
  <div class="page">
    <div class="half left">
      <div class="header_box">
        <div class="h_text">
          <span>{{ header.zy }}</span
          >{{ header.zw }} <span>{{ header.ey }}</span
          >{{ header.ew }}
        </div>
        <div class="h_pic"></div>
      </div>
      <div class="introduce">
        <div class="introduce_title">
          {{ title }}
        </div>
        <div class="introduce_text">
          {{ content }}
        </div>

        <div class="BAH">
          <a href="https://beian.mps.gov.cn/#/query/webSearch"
            >渝公网安备50019002502736号</a
          >
          &nbsp;
          <a href="https://beian.miit.gov.cn/#/Integrated/index"
            >渝ICP备17011311号-2</a
          >
        </div>
      </div>
    </div>

    <div class="half right">
      <div class="tfl_logo">
        <div class="logo"></div>
      </div>
      <div
        class="tfl_m ani"
        swiper-animate-effect="fadeInRight"
        swiper-animate-duration="2s"
        swiper-animate-delay="0s"
      >
        <div class="tfl_in">
          <div class="tfl_text_box">
            <div class="tfl_s">
              <p>{{ tfl.del1 }}</p>
              <p style="margin-top: 20px">{{ tfl.del2 }}</p>
            </div>
          </div>

          <div class="">
            <div class="tfl_arrow" @click="toPath(url)">
              <lottie
                :options="defaultOptions"
                :height="114"
                :width="114"
                @animCreated="handleAnimation"
              />
            </div>
            <div class="tfl_arrow_text">立即前往</div>
          </div>
        </div>
      </div>

      <!-- <div class="pages">
        <div
          class="ani flipm"
          swiper-animate-effect="flipInX"
          swiper-animate-duration="2s"
          swiper-animate-delay="0s"
        >
          {{ index }}
        </div>
        <div>/04</div>
      </div> -->
    </div>
  </div>
</template>
<script>
import lottie from "vue-lottie";
import arrow from "../../assets/arrow_right.json";
export default {
  props: {
    title: "",
    content: "",
    header: {},
    tfl: {},
    index: {
      type: String,
      default: "01",
    },
    url: "",
  },
  components: {
    lottie,
  },
  data() {
    return {
      defaultOptions: { animationData: arrow },
    };
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim;
    },
    toPath(path) {
      if (path == "https://dongcs.com") {
        window.open("https://dongcs.com", "_blank");
      } else {
        let routeUrl = this.$router.resolve({ path: path });
        window.open(routeUrl.href, "_blank");
      }
    },
  },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: PangMenZhengDao;
  src: url("../../assets/fonts/PangMenZhengDao.TTF") format("truetype");
}
.page {
  width: 100%;
  height: 100%;
  display: flex;
  font-family: Source Han Sans CN, Source Han Sans CN;
  background: #fff;
}
.half {
  height: 100%;
  flex: 1;
}
.left {
  background: url("/public/page-bg.png") no-repeat;
  background-size: 960px 100%;
  .header_box {
    position: absolute;
    bottom: 373px;
    left: 88px;
    width: 538px;
    height: 87px;
    background: #c71723;
    box-sizing: border-box;
    padding: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .h_text {
      font-weight: bold;
      font-size: 24px;
      color: #ffffff;
      line-height: 48px;
    }
    .h_pic {
      width: 15px;
      height: 16px;
      background: url("../../assets/h_logo.png") no-repeat;
      background-size: 15px 16px;
    }
    // span {
    //   color: #d8a076;
    // }
  }
  .introduce {
    position: absolute;
    bottom: 0;
    left: 88px;
    width: 872px;
    height: 373px;
    padding: 35px 60px;
    box-sizing: border-box;
    color: #1c1c1c;
    background: #fff;
  }
  .introduce_title {
    font-weight: bold;
    font-size: 24px;
    line-height: 48px;
    text-align: left;
  }
  .introduce_text {
    font-size: 18px;
    line-height: 40px;
    text-align: justify;
  }

  .BAH {
    position: absolute;
    left: 62px;
    bottom: 55px;
    font-size: 15px;
    color: #b9b9b9;
    line-height: 21px;
    a {
      text-decoration: none;
      color: #b9b9b9;
    }
  }
}
.right {
  background: linear-gradient(90deg, #f9f9f9 0%, rgba(245, 245, 245, 0) 100%);
}
.tfl_logo {
  width: 100%;
  height: 150px;
  display: flex;
  justify-content: end;
  .logo {
    width: 171px;
    height: 58px;
    background: url("../../assets/hk_logo_big.png") no-repeat;
    background-size: 171px 58px;
    margin: 50px 88px;
  }
}
.tfl_m {
  width: 797px;
  height: 330px;
  margin: 100px 58px 37px 58px;
  background: url("../../assets/ctfl_jb.png") no-repeat;
  background-size: 797px 265px;
  .tfl_in {
    width: 797px;
    padding-top: 170px;
    height: 160px;
    display: flex;
  }
  .tfl_text_box {
    width: 550px;
  }
  .tfl_t {
    font-weight: 800;
    font-size: 45px;
    color: #383838;
    line-height: 48px;
    text-align: left;
    margin-left: 48px;
  }
  .tfl_s {
    height: 28px;
    color: #1c1c1c;
    text-align: left;
    margin-left: 48px;
    line-height: 52px;
    margin-top: 8px;

    font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
    font-weight: bold;
    font-size: 42px;
  }
  // span {
  // color: #d43030;
  // }
}
.tfl_arrow {
  width: 114px;
  height: 114px;
  margin-left: 80px;
  cursor: pointer;
}

.tfl_arrow_text {
  width: 125px;
  margin-left: 80px;
  text-align: center;
  line-height: 0;
  font-size: 18px;
  color: #313131;
}
.pages {
  font-family: PangMenZhengDao, sans-serif;
  display: flex;
  align-items: center;
  position: absolute;
  left: 1630px;
  z-index: 20;
  bottom: 87px;
  width: 296px;
  font-size: 54px;
  color: #292929;
  font-weight: 400;
  text-align: center;
  .flipm {
    font-size: 72px;
    width: 105px;
    color: #c71723;
  }
}
</style>